import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=387b93e5&scoped=true"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"
import style0 from "./Goals.vue?vue&type=style&index=0&id=387b93e5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b93e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387b93e5')) {
      api.createRecord('387b93e5', component.options)
    } else {
      api.reload('387b93e5', component.options)
    }
    module.hot.accept("./Goals.vue?vue&type=template&id=387b93e5&scoped=true", function () {
      api.rerender('387b93e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/six/components/Goals.vue"
export default component.exports